import React from "react";
import { Layout, Menu, Button, Typography, Row, Col, Card } from "antd";
import { RocketOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

const { Header, Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const LandingPage = () => {
  // eslint-disable-next-line no-unused-vars
  // const { token } = theme.useToken();
  const darkBlue = "#001529";

  return (
    <Layout style={{ background: "#f0f2f5" }}>
      <Header
        style={{
          position: "fixed",
          zIndex: 100,
          width: "100%",
          background: "rgba(0, 21, 41, 0.8)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "12px",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <div
          style={{
            float: "left",
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginRight: 32,
          }}
        >
          <img
            src="/logoINFX.png"
            alt="Logo"
            style={{ height: "100%", maxHeight: 80, objectFit: "contain" }}
          />
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["1"]}
          style={{ background: darkBlue }}
        >
          <Menu.Item key="1">
            <a href="#inicio">Inicio</a>
          </Menu.Item>
          <Menu.Item key="2">
            <a href="#nosotros">Nosotros</a>
          </Menu.Item>
          <Menu.Item key="3">
            <a href="#servicios">Servicios</a>
          </Menu.Item>
          <Menu.Item key="4">
            <a href="#poly">POLY</a>
          </Menu.Item>
          <Menu.Item key="5">
            <a href="#contacto">Contacto</a>
          </Menu.Item>
        </Menu>
      </Header>

      <Content id="inicio" style={{ marginTop: 80, padding: "40px 60px" }}>
        <Row align="middle" justify="center" gutter={[48, 48]}>
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Title style={{ fontSize: "3em" }}>
                Bienvenido a INFX SOLUTION S.A.S
              </Title>
              <Paragraph
                style={{
                  fontSize: "1.2em",
                  lineHeight: 1.6,
                  textAlign: "justify",
                }}
              >
                Somos una empresa especializada en el desarrollo e
                implementación de soluciones de software a la medida. Contamos
                con un equipo humano con más de 20 años de experiencia en
                tecnologías de la información, que inició su trayectoria en el
                sector palmero y ha expandido su conocimiento hacia diversos
                sectores comerciales gracias a su entendimiento profundo de los
                negocios. <br />
                Combinamos innovación tecnológica, experiencia técnica y un
                enfoque centrado en el cliente para ofrecer soluciones
                integrales que mejoran la eficiencia, escalabilidad y
                competitividad de nuestros aliados. Nuestra convicción es lograr
                la satisfacción de quienes confían en nosotros, impulsando su
                transformación digital y convirtiendo ideas en productos
                digitales sólidos.
              </Paragraph>
              <Button
                type="primary"
                size="large"
                icon={<RocketOutlined />}
                shape="round"
              >
                <a href="#contacto" style={{ color: "white" }}>
                  Contáctanos
                </a>
              </Button>
            </motion.div>
          </Col>
          <Col xs={24} md={12}>
            <motion.img
              src="/INFORMACIONINFX.jpg"
              alt="Hero"
              style={{
                width: "100%",
                borderRadius: "20px",
                boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
              }}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            />
          </Col>
        </Row>

        <div style={{ marginTop: 100 }} id="nosotros">
          <Title level={2} style={{ textAlign: "center" }}>
            Misión y Visión
          </Title>
          <Row gutter={[24, 24]} justify="center" style={{ marginTop: 40 }}>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Card
                  title="Nuestra Misión"
                  bordered={false}
                  style={{
                    borderLeft: "6px solid #1677ff",
                    borderRadius: 16,
                    background: "white",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    height: "100%",
                  }}
                >
                  <Paragraph>
                    Proponer e Implementar soluciones tecnológicas prácticas e
                    innovadoras que se adapten a las necesidades de los
                    clientes.
                  </Paragraph>
                </Card>
              </motion.div>
            </Col>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <Card
                  title="Nuestra Visión"
                  bordered={false}
                  style={{
                    borderLeft: "6px solid #52c41a",
                    borderRadius: 16,
                    background: "white",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  }}
                >
                  <Paragraph>
                    Ser reconocidos como referentes en el desarrollo de software
                    a medida en Latinoamérica, liderando con tecnología de
                    vanguardia y un enfoque humano e innovador.
                  </Paragraph>
                </Card>
              </motion.div>
            </Col>
          </Row>
        </div>

        <div id="servicios" style={{ marginTop: 100 }}>
          <Title level={2} style={{ textAlign: "center" }}>
            Nuestros Servicios
          </Title>
          <Row gutter={[24, 24]} justify="center" style={{ marginTop: 40 }}>
            {[
              "Consultoría",
              "Desarrollo Web",
              "Software Dedicado",
              "Soluciones Agro",
            ].map((servicio, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  <Card
                    hoverable
                    style={{
                      borderRadius: 16,
                      textAlign: "center",
                      border: "none",
                      background: "white",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <Title level={4}>{servicio}</Title>
                    <Paragraph>
                      {servicio === "Consultoría"
                        ? "Asesoría especializada para proyectos tecnológicos."
                        : servicio === "Desarrollo Web"
                          ? "Sitios web modernos, rápidos y responsivos."
                          : servicio === "Software Dedicado"
                            ? "Software personalizado para necesidades específicas de tu empresa."
                            : "Herramientas digitales enfocadas al sector agroindustrial."}
                    </Paragraph>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>

        <div
          id="poly"
          style={{
            marginTop: 100,
            backgroundImage: "url('/icono-poli.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "rgba(255,255,255,0.95)",
            backgroundBlendMode: "lighten",
            padding: "60px 20px",
            borderRadius: 20,
          }}
        >
          <Row align="middle" gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <motion.img
                src="/logo-poli.png"
                alt="Poly Software"
                style={{
                  width: "100%",
                  borderRadius: 20,
                  boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                }}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              />
            </Col>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <Title level={2}>
                  POLY: Software para la Polinización de palma africana hibrida
                </Title>
                <Paragraph style={{ fontSize: "1.1em", textAlign: "justify" }}>
                  POLY es nuestra solución tecnológica diseñada para optimizar y
                  gestionar los procesos de polinización en cultivos de palma
                  africana hibrida. Este software permite capturar la
                  informacion de la polinizacion en campo, monitorear rutas de
                  los operadores, realizar supervision de la polinización,
                  llevar un control de el producto que se aplica en cada palma,
                  llevar un historial de la poliinización de cada una de las
                  palmas, coordinar labores, generar reportes precisos y ayuda
                  al agricultor a tomar decisiones basadas en datos para mejorar
                  la productividad agrícola. Ideal para productores que buscan
                  eficiencia, trazabilidad y sostenibilidad en sus cultivos de
                  palma africana.
                </Paragraph>
              </motion.div>
            </Col>
          </Row>
        </div>

        <motion.div
          id="contacto"
          style={{ marginTop: 100, textAlign: "center" }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Title level={2}>Contáctanos</Title>
          <Paragraph style={{ fontSize: "1.1em" }}>
            <PhoneOutlined /> +57 310 217 8291
            <br />
            <MailOutlined /> proyectos@infxsolution.com
          </Paragraph>
        </motion.div>
      </Content>

      <Footer style={{ textAlign: "center" }}>INFX SOLUTION S.A.S ©2025

        <br />
        <a href="/TYC_POLY2025.pdf" target="_blank" rel="noopener noreferrer">
          Ver Términos y Condiciones
        </a>
      </Footer>
    </Layout>
  );
};

export default LandingPage;
